import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BalanceRequest, BalanceResponse } from 'src/app/Interface/DataEntity/DataEntityBalanceForm_Interface';
@Injectable({ providedIn: 'root' })
export class DataEntityBalanceFormService {
 constructor(private http: HttpClient) {}
 get(id: number): Observable<BalanceResponse> { return this.http.get<BalanceResponse>(environment.LabUrl + 'api/Weight/BalanceCertificate?CalibrationDetailId=' + id); }
 save(model: BalanceRequest): Observable<BalanceResponse> { return this.http.post<BalanceResponse>(environment.LabUrl + 'api/Weight/BalanceCertificate', model); }
 calculate(model: BalanceRequest): Observable<any> { return this.http.post(environment.LabUrl + 'api/Weight/BalanceFinal', model); }
 downloadFile(path: string): Observable<Blob> {
  const normalized = path.replace(/\\/g, '/');
  const relative = normalized.includes('/') ? normalized : 'Certificates/balance/' + normalized;
  return this.http.get(/^https?:\/\//i.test(normalized) ? normalized : environment.LabUrl.replace(/\/+$/, '') + '/' + relative.replace(/^\/+/, ''), { responseType: 'blob' });
 }
}
